var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18460_216367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5822 10.4199H10.4243V33.5778H33.5822V10.4199Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5757 44.0011L43.9967 33.5801H33.5757V44.0011Z",
    fill: "#D82A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9967 10.4199H33.5757V33.5778H43.9967V10.4199Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5822 33.5801H10.4243V44.0011H33.5822V33.5801Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 33.5791V40.5265C0 42.4457 1.55447 44.0002 3.47368 44.0002H10.4211V33.5791H0Z",
    fill: "#188038"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9967 10.4211V3.47368C43.9967 1.55447 42.4423 0 40.5231 0H33.5757V10.4211H43.9967Z",
    fill: "#1967D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5789 0H3.47368C1.55447 0 0 1.55447 0 3.47368V33.5789H10.4211V10.4211H33.5789V0Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1722 28.3873C14.3067 27.8026 13.7075 26.9486 13.3804 25.8197L15.3893 24.9918C15.5717 25.6865 15.8901 26.2249 16.3446 26.607C16.7962 26.9891 17.3462 27.1773 17.9888 27.1773C18.6459 27.1773 19.2104 26.9776 19.6822 26.5781C20.1541 26.1786 20.3914 25.6691 20.3914 25.0526C20.3914 24.4215 20.1425 23.9062 19.6446 23.5068C19.1467 23.1073 18.5214 22.9076 17.7746 22.9076H16.6138V20.9189H17.6559C18.2985 20.9189 18.8398 20.7452 19.2798 20.3978C19.7198 20.0505 19.9398 19.5757 19.9398 18.9707C19.9398 18.4323 19.743 18.0039 19.3493 17.6826C18.9556 17.3612 18.4577 17.1991 17.8527 17.1991C17.2622 17.1991 16.7933 17.3554 16.4459 17.671C16.0988 17.9873 15.8378 18.3868 15.6875 18.8318L13.6988 18.0039C13.9622 17.257 14.4456 16.597 15.1548 16.0268C15.8641 15.4565 16.7701 15.1699 17.8701 15.1699C18.6835 15.1699 19.4159 15.3262 20.0643 15.6418C20.7127 15.9573 21.2222 16.3944 21.5898 16.9502C21.9575 17.5089 22.1398 18.1341 22.1398 18.8289C22.1398 19.5381 21.9691 20.1373 21.6275 20.6294C21.2859 21.1215 20.8662 21.4978 20.3683 21.7612V21.8799C21.0112 22.145 21.5696 22.5803 21.9835 23.1391C22.4033 23.7036 22.6146 24.3781 22.6146 25.1654C22.6146 25.9528 22.4148 26.6562 22.0154 27.2728C21.6159 27.8894 21.063 28.3757 20.3625 28.7289C19.6591 29.082 18.8688 29.2615 17.9917 29.2615C16.9756 29.2644 16.0377 28.972 15.1722 28.3873ZM27.5125 18.4178L25.3067 20.0128L24.2038 18.3397L28.1609 15.4855H29.6777V28.9489H27.5125V18.4178Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18460_216367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.05b53e7d.svg";
export { ForwardRef as ReactComponent };